export const GUIDE_QUESTIONS = [
    'interview-question-one',
    'interview-question-two',
    'interview-question-three',
    'interview-question-four'
];
